import {
  useHabitBarChartEntries,
  useHabitProgress,
  useUpdateHabitScheduleEntry,
} from 'features/tasks';
import React from 'react';
import { useUser } from 'shared/hooks/use-user';
import { ScheduleEntryState } from 'shared/types/habit-schedule';
import { ID } from 'shared/types/id';
import { InsightsTimeframes } from 'shared/types/insights';
import { Timestamp } from 'shared/types/timestamp';
import { getWeekStartsOn } from 'shared/utils/get-week-starts-on';

import { InsightsCard } from './insights-card';
import { HabitInsightsCardProps } from './types';

export const HabitInsightsMetricCard: React.FC<HabitInsightsCardProps> = ({
  habit,
  startDate,
  endDate,
  timeframe,
  referenceDate,
}) => {
  const user = useUser();
  const updateHabitEntry = useUpdateHabitScheduleEntry();
  const weekStartsOn = getWeekStartsOn(user);
  const { timeframeOccurrences, dateEntries } = useHabitProgress(habit, {
    startDate,
    endDate,
  });

  const {
    entries,
    perfectSlots,
    entriesValue,
    entriesTarget,
    target,
    completionPercentage,
  } = useHabitBarChartEntries(habit, {
    timeframe,
    startDate,
    endDate,
    weekStartsOn,
  });

  const _onDate = (
    _: ID,
    date: Timestamp,
    type: ScheduleEntryState,
    options?: { value?: number; increment?: number },
  ) =>
    // if there is no type, the completion progress has to be reset
    updateHabitEntry(habit, date, type, options);

  return (
    <InsightsCard
      habit={habit}
      calendarOpensToDate={referenceDate}
      entries={entries}
      entriesTarget={entriesTarget}
      calendarOccurrences={timeframeOccurrences}
      dateEntries={dateEntries}
      perfectSlots={perfectSlots}
      currentValue={entriesValue}
      completionPercentage={completionPercentage}
      weekStartsOn={getWeekStartsOn(user)}
      target={target}
      onDate={_onDate}
      displayMonth={timeframe === InsightsTimeframes.Month}
    />
  );
};
